document.addEventListener("DOMContentLoaded", function () {
  // Collection card colour swatches (image-swap variant):
  // clicking a swatch swaps the card's featured image to the selected
  // colour/variant image. Delegated so it also covers cards loaded via
  // infinite scroll / facet updates.
  document.addEventListener("click", function (e) {
    const swatchLink = e.target.closest(".cstm-swatches button[data-swatch-src]");
    if (!swatchLink) return; // not an image-swap swatch

    e.preventDefault();

    // Source image: the colour swatch button carries it in data-swatch-src.
    const newSrc = swatchLink.dataset.swatchSrc;
    if (!newSrc) return; // swatch has no image to apply

    // Nearest product card (card_style-agnostic).
    const card = swatchLink.closest(".product-card");
    if (!card) return;

    // Featured image inside the card media (secondary images live in an
    // inert <template> and are not matched here).
    const targetImg = card.querySelector(".product-card__media a img");
    if (!targetImg) return;

    // Update in place to preserve element semantics. The alt text names the
    // product and the colour now shown, as the card's photos do on load
    // (snippets/oros-photo-alt.liquid).
    targetImg.src = newSrc;
    targetImg.srcset = "";
    targetImg.removeAttribute("sizes");

    const productLink = card.querySelector(".product-card__media a[aria-label]");
    const colourName = swatchLink.querySelector(".tooltip");
    if (productLink && colourName) {
      targetImg.alt = productLink.getAttribute("aria-label") + ", " + colourName.textContent.trim();
    }

    // Mark the colour now shown (selected ring + state for screen readers).
    card.querySelectorAll(".cstm-swatches [aria-pressed]").forEach(function (swatch) {
      swatch.setAttribute("aria-pressed", swatch === swatchLink ? "true" : "false");
    });

    // Point the card's product links (image, title) at the picked colour so
    // the product page opens on it.
    const colourUrl = swatchLink.dataset.swatchUrl;
    if (colourUrl) {
      const colourPath = new URL(colourUrl, window.location.href).pathname;
      card.querySelectorAll("a[href]").forEach(function (link) {
        if (new URL(link.href, window.location.href).pathname === colourPath) {
          link.setAttribute("href", colourUrl);
        }
      });
    }
  });

  // Swatch tooltips sit centred over their swatch. Where that would run past the
  // card's edge (a row's first or last swatches, which depends on the card width),
  // anchor the tooltip to that side instead (see custom.css). Measured as the
  // pointer enters the card, before any swatch is hovered, so the tooltip doesn't
  // slide sideways as it appears.
  document.addEventListener("pointerover", function (e) {
    const card = e.target.closest(".product-card");
    if (!card || card.contains(e.relatedTarget)) return; // not entering a card

    const cardBox = card.getBoundingClientRect();
    const magnetReach = 5; // the magnet moves a hovered swatch up to 5px each way
    card.querySelectorAll(".variant_cstm-swatched .color-swatch").forEach(function (swatch) {
      const tooltip = swatch.querySelector(".tooltip");
      if (!tooltip) return;

      const swatchBox = swatch.getBoundingClientRect();
      const centre = swatchBox.left + swatchBox.width / 2;
      const halfWidth = tooltip.offsetWidth / 2 + magnetReach;
      if (centre - halfWidth < cardBox.left) {
        swatch.dataset.tooltipAlign = "start";
      } else if (centre + halfWidth > cardBox.right) {
        swatch.dataset.tooltipAlign = "end";
      } else {
        delete swatch.dataset.tooltipAlign;
      }
    });
  });

  // PDP photo badges with "Expanded text" (snippets/product-media.liquid) swap
  // their text for the longer one on click, and back on a second click.
  document.addEventListener("click", function (e) {
    const badge = e.target.closest(".oros-photo-badge--expandable");
    if (!badge) return;

    const expanded = badge.getAttribute("aria-expanded") === "true";
    badge.setAttribute("aria-expanded", expanded ? "false" : "true");
  });

  // Product page colour swatches: hovering one with a mouse shows its name in
  // the "Color:" label above the swatches, in place of the theme's tooltip,
  // which covered that label (hidden in custom.css). Leaving it puts the
  // selected colour's name back.
  document.addEventListener("pointerover", function (e) {
    if (e.pointerType !== "mouse") return;
    const swatch = e.target.closest("product-info .color-swatch");
    const fieldset = swatch && swatch.closest("fieldset");
    const label = fieldset && fieldset.querySelector(".form__label .font-medium");
    if (label) label.textContent = swatch.title;
  });

  document.addEventListener("pointerout", function (e) {
    const swatch = e.target.closest("product-info .color-swatch");
    if (!swatch || swatch.contains(e.relatedTarget)) return;

    const fieldset = swatch.closest("fieldset");
    const label = fieldset && fieldset.querySelector(".form__label .font-medium");
    const selected = fieldset && fieldset.querySelector("input:checked");
    if (label && selected) label.textContent = selected.value;
  });

  // The sticky add-to-cart bar's thumbnail has no alt text, as the bar's text
  // already names the product and options (main-product.liquid). The theme
  // swaps that photo on every variant change and copies the new photo's alt
  // text, which for colour-tagged photos is the tag (#color_fig), so it's
  // cleared again after the swap. The event doesn't bubble, hence the capture
  // listener; that runs before the theme's own, hence the timeout.
  document.addEventListener("variant:change", function () {
    setTimeout(function () {
      document.querySelectorAll("[data-sticky-product-media] img").forEach(function (img) {
        img.alt = "";
      });
    });
  }, true);

  // Back in stock: Klaviyo's "Notify me" stands in for the theme's own notify
  // button, whose contact form goes to Gorgias instead of Klaviyo's flow.
  // custom.css keeps the theme's button hidden while Klaviyo's is on its way,
  // which normally lands before the page has finished loading, even on a slow
  // phone connection. If Klaviyo's button doesn't turn up, the theme's comes
  // back: a second after the page has loaded when Klaviyo's script never ran
  // (an ad blocker), or once a sold-out size has gone 2s without it, at least
  // 3s after loading (the back-in-stock form switched off in Klaviyo). Once
  // Klaviyo's button has shown, it's left to Klaviyo.
  const buyButtons = document.querySelector("product-info .buy-buttons.back-in-stock");
  const submitButton = buyButtons && buyButtons.querySelector(".product-form__submit");
  if (submitButton && buyButtons.querySelector(".product-form__alert")) {
    const root = document.documentElement;
    const stickyForm = document.querySelector('product-sticky-form[form="' + submitButton.getAttribute("form") + '"]');
    const klaviyoNotify = function () {
      return buyButtons.querySelector("#klaviyo-bis-button-container");
    };
    let klaviyoSeen = false;
    let loadedAt = null;
    let soldOutSince = null;
    let fallbackTimer;

    const fallBack = function () {
      if (!klaviyoSeen && !klaviyoNotify()) root.classList.add("oros-bis-fallback");
    };

    const update = function () {
      if (submitButton.hasAttribute("loading")) return; // a size change still on its way

      if (klaviyoNotify()) {
        klaviyoSeen = true;
        root.classList.remove("oros-bis-fallback");
      }

      const soldOut = submitButton.matches("[disabled]:not([unavailable])");
      if (!soldOut) soldOutSince = null;
      else if (soldOutSince === null) soldOutSince = performance.now();

      clearTimeout(fallbackTimer);
      if (soldOut && !klaviyoSeen && loadedAt !== null) {
        fallbackTimer = setTimeout(fallBack, Math.max(loadedAt + 3000, soldOutSince + 2000) - performance.now());
      }

      // The sticky add-to-cart bar swaps its greyed-out cart button for a
      // notify one (main-product.liquid, custom.css)
      if (stickyForm) stickyForm.toggleAttribute("data-notify", soldOut);
    };

    const onLoad = function () {
      loadedAt = performance.now();
      // Klaviyo's script leaves these behind once it has run
      if (!window.klaviyoModulesObject && !window.__klKey) setTimeout(fallBack, 1000);
      update();
    };

    new MutationObserver(update).observe(buyButtons, { childList: true, subtree: true });
    new MutationObserver(update).observe(submitButton, { attributes: true, attributeFilter: ["disabled", "loading", "unavailable"] });
    if (document.readyState === "complete") onLoad();
    else window.addEventListener("load", onLoad);
    update();

    // The sticky bar's notify button opens Klaviyo's sign-up, or the theme's
    // when that's the one showing. Like the bar's cart button (theme.js), it
    // scrolls to the size options first while they're further down the page.
    if (stickyForm) {
      stickyForm.addEventListener("click", function (e) {
        if (!e.target.closest("[data-sticky-notify]")) return;

        const picker = stickyForm.variantPicker;
        if (picker && picker.getBoundingClientRect().bottom > window.innerHeight - stickyForm.offsetHeight) {
          picker.scrollIntoView({ behavior: theme.config.motionReduced ? "auto" : "smooth", block: "center" });
          const selected = picker.querySelector("input:checked");
          if (selected) selected.focus({ preventScroll: true });
          return;
        }

        const klaviyoButton = buyButtons.querySelector("#klaviyo-bis-button-container button");
        (klaviyoButton || buyButtons.querySelector(".product-form__alert")).click();
      });
    }
  }
});
